import React, {useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {BtnIconMoneyWrapper} from "../../../../../components/BtnIconMoneyWrapper";
import {Award1} from "../../../../../icons/Award1";
import {BtnIconMore2} from "../../../../../icons/BtnIconMore2";
import {ExchangeAlt1} from "../../../../../icons/ExchangeAlt1";
import {Icons19} from "../../../../../icons/Icons19";
import {TrailingIcon14} from "../../../../../icons/TrailingIcon14";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const AdultosLanding = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();
  const scrollRef = useRef(null);

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-card_details-adultos-mobile${currentParams}`);
  };

  return (
      <div className="adultos-landing" ref={scrollRef}>
        <div className="div-11">
          <div className="frame-108">
            <div className="frame-109">
              <div className="group-21">
                <div className="overlap-19">
                  <div className="btn-icon-money-wrapper">
                    <BtnIconMoneyWrapper />
                  </div>

                  <div className="group-22">
                    <div className="overlap-group-22">
                      <div className="text-wrapper-80">3</div>
                    </div>
                  </div>
                </div>
              </div>

              <p className="hello-mary">
              <span className="text-wrapper-81">
                Hello,
                <br />
              </span>

                <span className="text-wrapper-82">Mary</span>
              </p>
            </div>

            <div className="frame-110">
              <div className="group-23">
                <div className="text-wrapper-83">2,015 pts</div>

                <div className="award-wrapper">
                  <Award1 className="award" />
                </div>
              </div>

              <div className="iconly-light-outline-wrapper">
                <div className="more-square-wrapper">
                  <div className="more-square">
                    <div className="overlap-group-23">
                      <svg
                          width={25}
                          height={24}
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M21 7.665C21 5.135 19.267 3.5 16.584 3.5L8.416 3.5C5.733 3.5 4 5.135 4 7.665L4 16.333C4 18.864 5.733 20.5 8.416 20.5L16.584 20.5C19.267 20.5 21 18.864 21 16.334L21 7.665ZM2.5 16.333L2.5 7.665C2.5 4.276 4.878 2 8.416 2L16.584 2C20.122 2 22.5 4.276 22.5 7.665L22.5 16.334C22.5 19.723 20.122 22 16.584 22L8.416 22C4.878 22 2.5 19.723 2.5 16.333Z"
                            fill={colors.primario}
                        />
                        <path
                            d="M21 7.665L21.5 7.665L21 7.665ZM4 7.665L4.5 7.665L4 7.665ZM4 16.333L3.5 16.333L4 16.333ZM21 16.334L20.5 16.334L21 16.334ZM2.5 7.665L3 7.665L2.5 7.665ZM22.5 7.665L23 7.665L22.5 7.665ZM22.5 16.334L22 16.334L22.5 16.334ZM21.5 7.665C21.5 6.28138 21.023 5.10182 20.1412 4.27003C19.2623 3.44103 18.0268 3 16.584 3L16.584 4C17.8242 4 18.7967 4.37647 19.455 4.99747C20.1105 5.61568 20.5 6.51862 20.5 7.665L21.5 7.665ZM16.584 3L8.416 3L8.416 4L16.584 4L16.584 3ZM8.416 3C6.97316 3 5.73767 3.44103 4.8588 4.27002C3.97695 5.10182 3.5 6.28138 3.5 7.665L4.5 7.665C4.5 6.51862 4.88955 5.61568 5.54496 4.99747C6.20333 4.37647 7.17584 4 8.416 4L8.416 3ZM3.5 7.665L3.5 16.333L4.5 16.333L4.5 7.665L3.5 7.665ZM3.5 16.333C3.5 17.717 3.9769 18.8971 4.8587 19.7293C5.73756 20.5587 6.97308 21 8.416 21L8.416 20C7.17592 20 6.20344 19.6233 5.54505 19.002C4.8896 18.3834 4.5 17.4799 4.5 16.333L3.5 16.333ZM8.416 21L16.584 21L16.584 20L8.416 20L8.416 21ZM16.584 21C18.0269 21 19.2624 20.5587 20.1413 19.7294C21.0231 18.8974 21.5 17.7176 21.5 16.334L20.5 16.334C20.5 17.4804 20.1104 18.3836 19.455 19.0021C18.7966 19.6233 17.8241 20 16.584 20L16.584 21ZM21.5 16.334L21.5 7.665L20.5 7.665L20.5 16.334L21.5 16.334ZM3 16.333L3 7.665L2 7.665L2 16.333L3 16.333ZM3 7.665C3 6.09184 3.54915 4.81117 4.47703 3.92278C5.40682 3.03257 6.75523 2.5 8.416 2.5L8.416 1.5C6.53878 1.5 4.92918 2.10543 3.78547 3.20047C2.63985 4.29733 2 5.84916 2 7.665L3 7.665ZM8.416 2.5L16.584 2.5L16.584 1.5L8.416 1.5L8.416 2.5ZM16.584 2.5C18.2448 2.5 19.5932 3.03257 20.523 3.92278C21.4508 4.81117 22 6.09184 22 7.665L23 7.665C23 5.84916 22.3602 4.29733 21.2145 3.20047C20.0708 2.10543 18.4612 1.5 16.584 1.5L16.584 2.5ZM22 7.665L22 16.334L23 16.334L23 7.665L22 7.665ZM22 16.334C22 17.9072 21.4508 19.1881 20.5229 20.0768C19.5931 20.9672 18.2447 21.5 16.584 21.5L16.584 22.5C18.4613 22.5 20.0709 21.8943 21.2146 20.799C22.3602 19.7019 23 18.1498 23 16.334L22 16.334ZM16.584 21.5L8.416 21.5L8.416 22.5L16.584 22.5L16.584 21.5ZM8.416 21.5C6.75529 21.5 5.4069 20.9672 4.4771 20.0767C3.54919 19.1879 3 17.9067 3 16.333L2 16.333C2 18.1493 2.63981 19.7016 3.7854 20.7988C4.9291 21.8943 6.53871 22.5 8.416 22.5L8.416 21.5Z"
                            fill={colors.primario}
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.4863 15.9484C11.4863 15.3954 11.9333 14.9434 12.4863 14.9434C13.0393 14.9434 13.4863 15.3864 13.4863 15.9384L13.4863 15.9484C13.4863 16.5014 13.0393 16.9484 12.4863 16.9484C11.9333 16.9484 11.4863 16.5014 11.4863 15.9484Z"
                            fill={colors.primario}
                        />
                        <path
                            d="M11.4863 15.9484C11.4863 15.3954 11.9333 14.9434 12.4863 14.9434C13.0393 14.9434 13.4863 15.3864 13.4863 15.9384L13.4863 15.9484C13.4863 16.5014 13.0393 16.9484 12.4863 16.9484C11.9333 16.9484 11.4863 16.5014 11.4863 15.9484"
                            stroke={colors.primario}
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.4863 11.9386C11.4863 11.3856 11.9333 10.9346 12.4863 10.9346C13.0393 10.9346 13.4863 11.3766 13.4863 11.9296L13.4863 11.9386C13.4863 12.4916 13.0393 12.9386 12.4863 12.9386C11.9333 12.9386 11.4863 12.4916 11.4863 11.9386Z"
                            fill={colors.primario}
                        />
                        <path
                            d="M11.4863 11.9386C11.4863 11.3856 11.9333 10.9346 12.4863 10.9346C13.0393 10.9346 13.4863 11.3766 13.4863 11.9296L13.4863 11.9386C13.4863 12.4916 13.0393 12.9386 12.4863 12.9386C11.9333 12.9386 11.4863 12.4916 11.4863 11.9386"
                            stroke={colors.primario}
                        />
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.4863 7.9298C11.4863 7.3768 11.9333 6.9248 12.4863 6.9248C13.0393 6.9248 13.4863 7.3678 13.4863 7.9208L13.4863 7.9298C13.4863 8.4828 13.0393 8.9298 12.4863 8.9298C11.9333 8.9298 11.4863 8.4828 11.4863 7.9298Z"
                            fill={colors.primario}
                        />
                        <path
                            d="M11.4863 7.9298C11.4863 7.3768 11.9333 6.9248 12.4863 6.9248C13.0393 6.9248 13.4863 7.3678 13.4863 7.9208L13.4863 7.9298C13.4863 8.4828 13.0393 8.9298 12.4863 8.9298C11.9333 8.9298 11.4863 8.4828 11.4863 7.9298"
                            stroke={colors.primario}
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="frame-111">
            <div className="btn-switch">
              <div className="selected">
                <div className="text-wrapper-84">Wealth</div>
              </div>

              <div className="element-3">
                <div className="text-wrapper-85">Transactions</div>
              </div>

              <div className="element-3">
                <div className="text-wrapper-85">Rewards</div>
              </div>
            </div>

            <div className="element-4">
              <div className="div-12">
                <div className="text-wrapper-86">My Products</div>

                <div className="frame-112">
                  <Icons19 className="icons-5" color="var(--secundario)" />
                  <div className="menu-copy-2">
                    <div className="oval-7" />

                    <div className="oval-8" />

                    <div className="oval-9" />
                  </div>
                </div>
              </div>

              <div className="accounts-2">
                <div className="overlap-20">
                  {/* <div className="credit">
                  <div className="overlap-group-24">
                    <div className="cvv">
                      <div className="element-5">
                        <div className="text-wrapper-87">Available</div>

                        <div className="element-6">
                          <div className="text-wrapper-88">$</div>

                          <p className="element-USD-2">
                            <span className="text-wrapper-89">550</span>

                            <span className="text-wrapper-90">.00 </span>

                            <span className="text-wrapper-91">USD</span>
                          </p>
                        </div>
                      </div>

                      <div className="iconly-light-outline-3">
                        <div className="text-wrapper-92">CVV</div>

                        <img
                          className="search"
                          alt="Search"
                          src="/img/search.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-113">
                      <div className="div-12">
                        <div className="frame-114">
                          <img
                            className="modo-de-aislamiento"
                            alt="Modo de aislamiento"
                            src="/img/modo-de-aislamiento.svg"
                          />

                          <div className="text-wrapper-93">Credit VX</div>

                          <TrailingIcon25 className="trailing-icon-25" />
                        </div>

                        <div className="frame-115">
                          <img
                            className="logo-visa-5"
                            alt="Logo visa"
                            src="/img/logo-visa-4.svg"
                          />

                          <Nfc1 className="NFC" />
                        </div>
                      </div>

                      <div className="frame-116">
                        <img
                          className="group-24"
                          alt="Group"
                          src="/img/group-9.png"
                        />

                        <div className="numero">
                          <div className="text-wrapper-94">
                            **** **** **** 2345
                          </div>

                          <RegularCopyAlt3 className="regular-copy-alt-3" />
                        </div>

                        <div className="fecha-pago-3">
                          <Icons14 className="icons-14" />
                          <div className="frame-117">
                            <div className="text-wrapper-95">Pay date</div>

                            <div className="text-wrapper-96">22-AGO</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                  {/* <div className="credit-2">
                  <div className="overlap-21">
                    <div className="cvv-2">
                      <div className="element-7">
                        <div className="text-wrapper-97">Available</div>

                        <div className="element-8">
                          <div className="text-wrapper-98">$</div>

                          <p className="element-USD-3">
                            <span className="text-wrapper-99">1,250</span>

                            <span className="text-wrapper-100">&nbsp;</span>

                            <span className="text-wrapper-101">USD</span>
                          </p>
                        </div>
                      </div>

                      <div className="iconly-light-outline-4">
                        <div className="text-wrapper-102">CVV</div>

                        <img
                          className="icon-instance-node-3"
                          alt="Search"
                          src="/img/search-1.svg"
                        />
                      </div>
                    </div>

                    <div className="frame-118">
                      <div className="div-12">
                        <div className="frame-119">
                          <img
                            className="modo-de-aislamiento-2"
                            alt="Modo de aislamiento"
                            src="/img/modo-de-aislamiento-1.svg"
                          />

                          <div className="text-wrapper-103">Credit Gold VX</div>

                          <TrailingIcon26 className="icon-instance-node-3" />
                        </div>

                        <div className="frame-120">
                          <img
                            className="logo-visa-6"
                            alt="Logo visa"
                            src="/img/logo-visa-5.svg"
                          />

                          <Nfc2 className="nfc-2" />
                        </div>
                      </div>

                      <div className="div-12">
                        <img
                          className="group-25"
                          alt="Group"
                          src="/img/group-9-1.png"
                        />

                        <div className="numero-2">
                          <div className="text-wrapper-104">
                            **** **** **** 5849
                          </div>

                          <RegularCopyAlt4 className="regular-copy-alt-4" />
                        </div>

                        <div className="fecha-pago-4">
                          <Icons15 className="icon-instance-node-3" />
                          <div className="frame-117">
                            <div className="text-wrapper-105">Pay date</div>

                            <div className="text-wrapper-106">29-FEB</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                  <div
                      className="debit-3 highlighted-button"
                      onClick={handleButtonClick}
                  >
                    <div className="overlap-22">
                      {/* <img
                      className="group-26"
                      alt="Group"
                      src="/img/group-3.png"
                    />

                    <img
                      className="group-27"
                      alt="Group"
                      src="/img/group-4.png"
                    /> */}

                      <div className="frame-121">
                        <div className="frame-122">
                          <div className="text-wrapper-107">Balance</div>

                          <div className="frame-123">
                            <div className="text-wrapper-108">$</div>

                            <div className="frame-124">
                              <div className="text-wrapper-109">13,000</div>

                              <div className="text-wrapper-110">.23</div>
                            </div>

                            <div className="text-wrapper-111">USD</div>
                          </div>
                        </div>

                        <div className="text-wrapper-112">Digital Account</div>
                      </div>

                      <div className="frame-125">
                        <div className="text-wrapper-113">
                          Debit Card ****2357
                        </div>

                        <TrailingIcon14
                            className="trailing-icon-4"
                            color="white"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="element-9">
              <div className="div-13">
                <img className="group-28" alt="Group" src="/img/group-638.svg" />

                <div className="frame-126">
                  <div className="frame-127">
                    <div className="ellipse-17" />

                    <p className="div-14">
                    <span className="text-wrapper-114">
                      T. Balance
                      <br />
                    </span>

                      <span className="text-wrapper-115">$13,000</span>
                    </p>
                  </div>

                  <div className="frame-127">
                    <div className="ellipse-18" />

                    <p className="div-14">
                    <span className="text-wrapper-114">
                      Debts
                      <br />
                    </span>

                      <span className="text-wrapper-115">$8,000</span>
                    </p>
                  </div>
                </div>

                <div className="frame-128">
                  <div className="text-wrapper-116">Total balance | Debts</div>

                  <TrailingIcon14
                      className="trailing-icon-4"
                      color={colors.primario}
                  />
                </div>
              </div>

              <div className="div-13">
                <div className="frame-129">
                  <div className="frame-130">
                    <div className="text-wrapper-116">Expenses &amp; Incomes</div>

                    <TrailingIcon14
                        className="trailing-icon-4"
                        color={colors.primario}
                    />
                  </div>

                  <div className="chart-2">
                    <div className="frame-131">
                      <div className="rectangle-24" />

                      <div className="rectangle-25" />
                    </div>

                    <div className="frame-131">
                      <div className="rectangle-26" />

                      <div className="rectangle-27" />
                    </div>
                  </div>

                  <div className="frame-132">
                    <div className="text-wrapper-117">September</div>

                    <div className="frame-133">
                      <div className="frame-134">
                        <p className="div-15">
                        <span className="text-wrapper-114">
                          Expenses
                          <br />
                        </span>

                          <span className="text-wrapper-118">$2,000</span>
                        </p>
                      </div>

                      <div className="frame-135">
                        <p className="div-15">
                        <span className="text-wrapper-114">
                          Incomes
                          <br />
                        </span>

                          <span className="text-wrapper-118">$3,200</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="element-4">
              <div className="subsection-wrapper">
                <div className="subsection-4">
                  <div className="frame-136">
                    <div className="subsection-5">My Goals</div>
                  </div>

                  <div className="frame-137">
                    <div className="btn-text-link-4">
                      <div className="text-link-2">Manage</div>
                    </div>

                    <BtnIconMore2 className="icons-5" />
                  </div>
                </div>
              </div>

              <div className="goals">
                <div className="goal">
                  <div className="frame-138">
                    <div className="text-wrapper-119">Europe travel</div>

                    <div className="text-wrapper-120">$8,700</div>
                  </div>

                  <img className="image-9" alt="Image" src="/img/image-217.png" />

                  <div className="group-29">
                    <div className="rectangle-28" />
                  </div>

                  <div className="text-wrapper-121">15%</div>
                </div>

                <div className="goal">
                  <div className="frame-138">
                    <div className="text-wrapper-119">New iPhone</div>

                    <div className="text-wrapper-120">$700.54</div>
                  </div>

                  <div className="group-29">
                    <div className="rectangle-29" />
                  </div>

                  <div className="text-wrapper-121">85%</div>

                  <img
                      className="image-10"
                      alt="Image"
                      src="/img/image-61980-1.png"
                  />
                </div>

                <div className="goal">
                  <div className="frame-138">
                    <div className="text-wrapper-119">Xmas gifts</div>

                    <div className="text-wrapper-120">$3,980</div>
                  </div>

                  <img
                      className="image-11"
                      alt="Image"
                      src="/img/image-61589.png"
                  />

                  <div className="group-29">
                    <div className="rectangle-30" />
                  </div>

                  <div className="text-wrapper-121">90%</div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="navs-statusbar-4">
          <div className="content-6">
            <div className="text-wrapper-122">9:50</div>

            <img className="icons-6" alt="Icons" src="/img/icons-16.svg" />
          </div>
        </div> */}


          <div className="menu-2">
            <div className="icon-and-text-5">
              <svg
                  width={25}
                  height={24}
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M19.918 12C19.918 12.2652 19.8126 12.5196 19.6251 12.7071C19.4375 12.8946 19.1832 13 18.918 13C18.6528 13 18.3984 12.8946 18.2109 12.7071C18.0233 12.5196 17.918 12.2652 17.918 12C17.918 11.7348 18.0233 11.4804 18.2109 11.2929C18.3984 11.1054 18.6528 11 18.918 11C19.1832 11 19.4375 11.1054 19.6251 11.2929C19.8126 11.4804 19.918 11.7348 19.918 12Z"
                    fill={colors.primario}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.862 3.25H13.974C15.812 3.25 17.268 3.25 18.407 3.403C19.579 3.561 20.528 3.893 21.277 4.641C22.201 5.566 22.496 6.804 22.603 8.411C23.18 8.664 23.616 9.201 23.663 9.881C23.668 9.942 23.668 10.007 23.668 10.067V13.933C23.668 13.993 23.668 14.058 23.664 14.118C23.616 14.798 23.18 15.336 22.603 15.59C22.496 17.196 22.201 18.434 21.277 19.359C20.528 20.107 19.579 20.439 18.407 20.597C17.267 20.75 15.812 20.75 13.974 20.75H10.862C9.02397 20.75 7.56797 20.75 6.42897 20.597C5.25697 20.439 4.30797 20.107 3.55897 19.359C2.81097 18.61 2.47897 17.661 2.32097 16.489C2.16797 15.349 2.16797 13.894 2.16797 12.056V11.944C2.16797 10.106 2.16797 8.65 2.32097 7.511C2.47897 6.339 2.81097 5.39 3.55897 4.641C4.30797 3.893 5.25697 3.561 6.42897 3.403C7.56897 3.25 9.02397 3.25 10.862 3.25ZM21.086 15.75H19.148C17.003 15.75 15.167 14.122 15.167 12C15.167 9.878 17.003 8.25 19.147 8.25H21.085C20.971 6.909 20.714 6.2 20.215 5.702C19.792 5.279 19.212 5.025 18.206 4.89C17.179 4.752 15.824 4.75 13.917 4.75H10.917C9.00997 4.75 7.65597 4.752 6.62697 4.89C5.62197 5.025 5.04197 5.279 4.61897 5.702C4.19597 6.125 3.94197 6.705 3.80697 7.711C3.66897 8.739 3.66697 10.093 3.66697 12C3.66697 13.907 3.66897 15.262 3.80697 16.29C3.94197 17.295 4.19597 17.875 4.61897 18.298C5.04197 18.721 5.62197 18.975 6.62797 19.11C7.65597 19.248 9.00997 19.25 10.917 19.25H13.917C15.824 19.25 17.179 19.248 18.207 19.11C19.212 18.975 19.792 18.721 20.215 18.298C20.714 17.8 20.972 17.092 21.086 15.75ZM6.16797 8C6.16797 7.80109 6.24699 7.61032 6.38764 7.46967C6.52829 7.32902 6.71906 7.25 6.91797 7.25H10.918C11.1169 7.25 11.3076 7.32902 11.4483 7.46967C11.589 7.61032 11.668 7.80109 11.668 8C11.668 8.19891 11.589 8.38968 11.4483 8.53033C11.3076 8.67098 11.1169 8.75 10.918 8.75H6.91797C6.71906 8.75 6.52829 8.67098 6.38764 8.53033C6.24699 8.38968 6.16797 8.19891 6.16797 8ZM21.842 9.75H19.148C17.724 9.75 16.667 10.809 16.667 12C16.667 13.191 17.724 14.25 19.147 14.25H21.865C22.071 14.237 22.16 14.098 22.167 14.014V9.986C22.16 9.902 22.071 9.763 21.865 9.751H21.841L21.842 9.75Z"
                    fill={colors.primario}
                />
              </svg>

              <div className="text-5">Accounts</div>
            </div>

            <div className="icon-and-text-5">
              <ExchangeAlt1 className="exchange-alt" color={colors.primario} />
              <div className="text-5">Transfers</div>
            </div>

            <div className="icon-and-text-6">
              <svg
                  width={21}
                  height={20}
                  viewBox="0 0 21 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.81465 5.7C8.26365 6.113 8.01465 6.608 8.01465 7.07C8.01465 7.533 8.26365 8.028 8.81465 8.442C9.36665 8.856 10.1746 9.142 11.1096 9.142C11.3749 9.142 11.6292 9.24736 11.8168 9.43489C12.0043 9.62243 12.1096 9.87678 12.1096 10.142C12.1096 10.4072 12.0043 10.6616 11.8168 10.8491C11.6292 11.0366 11.3749 11.142 11.1096 11.142C9.78365 11.142 8.54465 10.74 7.61465 10.042C6.68465 9.344 6.01465 8.304 6.01465 7.071C6.01465 5.837 6.68465 4.797 7.61465 4.099C8.54465 3.402 9.78465 3 11.1096 3C13.1626 3 15.1036 3.983 15.8756 5.62C15.9317 5.73885 15.9637 5.86756 15.97 5.99879C15.9762 6.13003 15.9566 6.26121 15.9122 6.38485C15.8677 6.50849 15.7994 6.62217 15.711 6.7194C15.6226 6.81662 15.516 6.89549 15.3971 6.9515C15.2783 7.00751 15.1496 7.03956 15.0184 7.04583C14.8871 7.05209 14.7559 7.03245 14.6323 6.98801C14.5087 6.94358 14.395 6.87523 14.2978 6.78686C14.2005 6.6985 14.1217 6.59185 14.0656 6.473C13.7156 5.726 12.6236 5 11.1106 5C10.1756 5 9.36665 5.286 8.81465 5.7Z"
                    fill={colors.primario}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.0745 14.583C13.6255 14.17 13.8735 13.675 13.8735 13.213C13.8735 12.75 13.6255 12.254 13.0735 11.841C12.5225 11.427 11.7135 11.141 10.7795 11.141C10.5143 11.141 10.2599 11.0356 10.0724 10.8481C9.88484 10.6606 9.77948 10.4062 9.77948 10.141C9.77948 9.87578 9.88484 9.62143 10.0724 9.43389C10.2599 9.24636 10.5143 9.141 10.7795 9.141C12.1055 9.141 13.3445 9.543 14.2745 10.241C15.2045 10.939 15.8735 11.979 15.8735 13.212C15.8735 14.445 15.2045 15.486 14.2735 16.183C13.3435 16.881 12.1055 17.283 10.7795 17.283C8.72648 17.283 6.78448 16.3 6.01348 14.662C5.90037 14.4221 5.88718 14.1471 5.97682 13.8975C6.06646 13.6479 6.25159 13.4441 6.49148 13.331C6.73137 13.2179 7.00637 13.2047 7.25598 13.2943C7.50559 13.384 7.70937 13.5691 7.82248 13.809C8.17448 14.557 9.26648 15.283 10.7795 15.283C11.7145 15.283 12.5225 14.997 13.0745 14.583ZM10.9175 1C11.1827 1 11.4371 1.10536 11.6246 1.29289C11.8121 1.48043 11.9175 1.73478 11.9175 2V3C11.9175 3.26522 11.8121 3.51957 11.6246 3.70711C11.4371 3.89464 11.1827 4 10.9175 4C10.6523 4 10.3979 3.89464 10.2104 3.70711C10.0228 3.51957 9.91748 3.26522 9.91748 3V2C9.91748 1.73478 10.0228 1.48043 10.2104 1.29289C10.3979 1.10536 10.6523 1 10.9175 1Z"
                    fill={colors.primario}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.918 16C11.1832 16 11.4375 16.1054 11.6251 16.2929C11.8126 16.4804 11.918 16.7348 11.918 17V18C11.918 18.2652 11.8126 18.5196 11.6251 18.7071C11.4375 18.8946 11.1832 19 10.918 19C10.6528 19 10.3984 18.8946 10.2109 18.7071C10.0233 18.5196 9.91797 18.2652 9.91797 18V17C9.91797 16.7348 10.0233 16.4804 10.2109 16.2929C10.3984 16.1054 10.6528 16 10.918 16Z"
                    fill={colors.primario}
                />
              </svg>

              <div className="text-6">Bills | TopUps</div>
            </div>

            <div className="icon-and-text-5">
              <svg
                  width={25}
                  height={24}
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M10.918 17.5C10.918 15.567 9.35097 14 7.41797 14C5.48497 14 3.91797 15.567 3.91797 17.5C3.91797 19.433 5.48497 21 7.41797 21C9.35096 21 10.918 19.433 10.918 17.5Z"
                    stroke={colors.primario}
                    strokeWidth={1.99832}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.918 6.5C10.918 4.567 9.35097 3 7.41797 3C5.48497 3 3.91797 4.567 3.91797 6.5C3.91797 8.433 5.48497 10 7.41797 10C9.35096 10 10.918 8.433 10.918 6.5Z"
                    stroke={colors.primario}
                    strokeWidth={1.99832}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.918 6.5C21.918 4.567 20.351 3 18.418 3C16.485 3 14.918 4.567 14.918 6.5C14.918 8.433 16.485 10 18.418 10C20.351 10 21.918 8.433 21.918 6.5Z"
                    stroke={colors.primario}
                    strokeWidth={1.99832}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.418 14V21"
                    stroke={colors.primario}
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.918 17.5156H21.918"
                    stroke={colors.primario}
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
              </svg>

              <div className="text-5">Hub</div>
            </div>
          </div>
        </div>
      </div>
  );
};
